export const customers = {
  CREATED: "CREATED",
  ACTIVATED: "ACTIVATED",
};
